import {
    REMOVE_AREA_START,
    REMOVE_AREA_SUCCESS,
    REMOVE_AREA_ERROR
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.remove, action = {type: ''}) => {
    switch (action.type) {
        case REMOVE_AREA_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case REMOVE_AREA_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case REMOVE_AREA_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/removeAreaReducer.js